var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#B8FFCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3222 6.875C17.4778 6.875 18.75 8.11537 18.75 10.2386H16.1056V10.2603C14.8783 10.2603 13.8833 11.2303 13.8833 12.4269C13.8833 13.6235 14.8783 14.5935 16.1056 14.5935H18.75V14.7885C18.75 16.8846 17.4778 18.125 15.3222 18.125H9.67778C7.52222 18.125 6.25 16.8846 6.25 14.7885V10.2115C6.25 8.11537 7.52222 6.875 9.67778 6.875H15.3222ZM18.2833 11.1703C18.5411 11.1703 18.75 11.374 18.75 11.6252V13.2068C18.747 13.4569 18.5398 13.6589 18.2833 13.6618H16.1556C15.5342 13.67 14.9909 13.2552 14.85 12.6652C14.7794 12.2989 14.8785 11.921 15.1207 11.6326C15.3628 11.3443 15.7233 11.175 16.1056 11.1703H18.2833ZM16.4056 11.9015H16.2C16.0738 11.9 15.9523 11.9479 15.8625 12.0344C15.7727 12.1209 15.7222 12.2388 15.7222 12.3619C15.7222 12.62 15.9352 12.8301 16.2 12.8331H16.4056C16.6694 12.8331 16.8833 12.6246 16.8833 12.3673C16.8833 12.11 16.6694 11.9015 16.4056 11.9015ZM12.7389 9.30699H9.21111C8.9494 9.30698 8.73638 9.51225 8.73333 9.76739C8.73333 10.0255 8.94635 10.2357 9.21111 10.2386H12.7389C13.0028 10.2386 13.2167 10.0301 13.2167 9.77281C13.2167 9.51555 13.0028 9.30699 12.7389 9.30699Z",
    fill: "#299B0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeIcon);
export default __webpack_public_path__ + "static/media/income-icon.4eace539e63de3e4c8c79f9e9e343c6a.svg";
export { ForwardRef as ReactComponent };